// We need to import the CSS so that webpack will load it.
// The MiniCssExtractPlugin is used to separate it out into
// its own CSS file.
import "../css/app.scss"

// webpack automatically bundles all modules in your
// entry points. Those entry points can be configured
// in "webpack.config.js".
//
// Import deps with the dep name or local files with a relative path, for example:
//
//     import {Socket} from "phoenix"
//     import socket from "./socket"
//
import "phoenix_html"

import React from 'react'
import ReactDOM from 'react-dom'
import { AppProvider } from '@shopify/polaris'
import enTranslations from '@shopify/polaris/locales/en.json'
import '@shopify/polaris/styles.css'

import Settings from './components/settings'
import OrderSummary from './components/order_summary'
import PrintSummaryTable from './components/print_summary_table'

function WrappedApp(props) {
  return ReactDOM.render(
    <AppProvider i18n={enTranslations}>
      <Settings shop_url={props.shop_url} jwt={props.jwt} />
    </AppProvider>,
    document.getElementById("root")
  )
}

function WrappedOrderSummary(props) {
  return ReactDOM.render(
    <AppProvider i18n={enTranslations}>
      <OrderSummary
        summary_line_items={props.summary_line_items}
        unfulfilled_summary_line_items={props.unfulfilled_summary_line_items}
        order_address_map={props.order_address_map}
        order_notes={props.order_notes}
        jwt={props.jwt}
        order_ids={props.order_ids}
      />
    </AppProvider>,
    document.getElementById("root")
  )
}

function WrappedPrintSummary(props) {
  return ReactDOM.render(
    <AppProvider i18n={enTranslations}>
      <PrintSummaryTable
        rows={props.summary_line_items}
        showBarcodes={props.show_barcodes}
        showImages={props.show_images}
        showShippingLines={props.show_shipping_lines}
        order_address_map={props.order_address_map}
        order_notes={props.order_notes}
        filter={""} />
    </AppProvider>,
    document.getElementById("root")
  );
}

function inIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}

window.Components = {
  WrappedApp,
  WrappedOrderSummary,
  WrappedPrintSummary
}